import React, { Component } from "react";
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import { setStep } from '../../store/actions/FormAction';

class NextStepButton extends Component {
    render() {
      let addDisabledToClasses = this.props.btnClasses + " disabled";

      if (this.props.hideNext){
        return "";
      }
      switch(this.props.disableNext){
        case true:
          return (
            <Link className={addDisabledToClasses} to="/#" >
              <span>{this.props.btnText}</span>
            </Link>
          )
        default:
          return (
            <Link id={this.props.id} className={this.props.btnClasses} to={this.props.next} onClick={()=> !this.props.disableNext ? this.props.setStep(this.props.step) : ()=>{}} tabIndex={this.props.tabIndex} >
              <button type="submit">{this.props.btnText}</button>
            </Link>
          )
      }
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    setStep: (step) => dispatch(setStep(step)),
});
/*
    Can put mapStateToProps or state => ({}) as first param of connect()
    Using mapStateToProps for simplicity and stylistic preference
*/
export default connect(mapStateToProps, mapDispatchToProps)(NextStepButton)



// WEBPACK FOOTER //
// ./src/components/partials/NextButton.js